<template>
  <div class="content-430 page-index">
    <div class="block-content">
      <div class="block-title">选择退款内容</div>
      <Alert type="warning">
        <span style="color:rgb(245, 154, 35)"><strong>提示：</strong>仅支持统计银行侧<strong style="font-size:18px;color:red">已结算完成</strong>的订单关联，且该订单已存在待退款单或请假可退款的数据汇总</span>
      </Alert>
      <RefundApplicationSearch ref="searchRef" :sheet-id="sheetId" :school-id="searchConds.schoolId" @on-search="getParams"></RefundApplicationSearch>
    </div>
    <div class="block-content">
      <div class="block-title">待退款明细</div>
      <Tabs v-if="tabs.length>0" type="card" @on-click="tabChange">
        <TabPane v-for="tab in tabs" :key="tab.value" :name="tab.value" :label="tab.name"></TabPane>
      </Tabs>
      <div class="table-main">
        <Table
          :columns="listColumnsShow"
          :data="tableList"
          :loading="loading"
          :max-height="500"
          border
          @on-selection-change="getSelection"
        >
          <template slot="classTimeDesc" slot-scope="{ row }">
            <TablePoptip :content="row.classTimeDesc" :show-poptips-content-length="30" :content-width="230"> </TablePoptip>
          </template>
          <template slot="appliedAmt" slot-scope="{ row }">
            {{ row.appliedAmt | showFee }}
          </template>
          <template slot="refundReqType" slot-scope="{ row }">
            {{ refundReqTypeInfo[row.refundReqType] }}
          </template>
        </Table>
      </div>
      <div class="page-wrap">
        <Page
          :current="pageInfo.pageNum"
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          :page-size-opts="pageSizeOpts"
          show-sizer
          show-total
          show-elevator
          @on-change="pageChange"
          @on-page-size-change="handlePageSize"
        ></Page>
      </div>
      <Row v-if="sheetId" class="row row-line">

        <Col style="margin-right: 32px">合计金额：<span class="color-red">{{
          totalFeeForSelect | showFee
        }}</span>元</Col>
        <Col style="margin-right: 32px">待退款课程金额（含已入班、未入班、材料费）：<span class="color-red">{{ refundFeeForSelect | showFee }}</span>元</Col>
        <Col style="margin-right: 32px">请假可退款：<span class="color-red">{{ leaveFeeForSelect | showFee }}</span>元</Col>
        <Col class="color-red">注意：实际退款发起金额以系统处理成功为准！</Col>
      </Row>
      <Row v-else class="row row-line">

        <Col style="margin-right: 32px">合计金额：<span class="color-red">{{
          totalFee | showFee
        }}</span>元</Col>
        <Col style="margin-right: 32px">待退款课程金额（含已入班、未入班、材料费）：<span class="color-red">{{ refundFee | showFee }}</span>元</Col>
        <Col style="margin-right: 32px">请假可退款：<span class="color-red">{{ leaveRefundFee | showFee }}</span>元</Col>
        <Col class="color-red">注意：实际退款发起金额以系统处理成功为准！</Col>
      </Row>
    </div>
    <div class="formbtnbox-430-bottom">
      <Button v-if="!sheetId" @click="handleToLastStep">上一步</Button>
      <Button
        type="primary"
        :loading="isSaveing"
        :disabled="isSaveing"
        @click="handleCheckAllForm"
      >保存</Button>
      <Button @click="handleGoBack">取消</Button>
    </div>
    <CheckCodeModal
      ref="checkCodeModalRef"
      :check-type="checkType"
      modal-title="退款申请单"
      :modal-text="codeModalText"
      @sendCode="getPhoneCode"
    ></CheckCodeModal>
    <LoadingModal
      ref="loadingModal"
      modal-title="提示"
      modal-content="退款申请单创建中，请勿关闭当前页面！"
    ></LoadingModal>
    <ResultModal
      ref="resultModal"
      :modal-type="modalType"
      :modal-text="resultModalText"
      @closeModal="handleClickSure"
    ></ResultModal>
  </div>
</template>

<script>
import orderCenterApi from '@/request/orderCenter/index.js';
import RefundApplicationSearch from './RefundApplicationSearch';
import CheckCodeModal from './CheckCodeModal.vue';
import LoadingModal from './LoadingModal';
import ResultModal from './ResultModal';

import { moneyFenChangeYuan, add } from '@/utils/utils';
export default {
  components: {
    RefundApplicationSearch,
    CheckCodeModal,
    LoadingModal,
    ResultModal
  },
  filters: {
    showFee(fee) {
      return moneyFenChangeYuan(fee);
    }
  },
  props: {
    sheetId: {
      type: String,
      default: ''
    },
    searchConds: {
      type: Object,
      default: () => {
        return {
          schoolId: '',
          yearCode: '',
          termCode: '',
          areaCode: ''
        };
      }
    }
  },
  data() {
    return {
      refundListColumns: [
        {
          title: '退款单号',
          key: 'appliedId',
          minWidth: 200
        },
        {
          title: '订单编号',
          key: 'orderId',
          minWidth: 200
        },
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 120
        },
        {
          title: '学校名称',
          key: 'schoolName',
          tooltip: true,
          minWidth: 180
        },
        {
          title: '年级班级',
          key: 'gradeClassName',
          minWidth: 120
        },
        {
          title: '学期',
          key: 'yearTerm',
          minWidth: 200
        },
        {
          title: '退款类型',
          key: 'refundType',
          minWidth: 120
        },
        {
          title: '商品名称',
          key: 'offerName',
          tooltip: true,
          minWidth: 200
        },
        {
          title: '机构名称',
          key: 'orgName',
          tooltip: true,
          minWidth: 170
        },
        {
          title: '上课时间',
          slot: 'classTimeDesc',
          tooltip: true,
          minWidth: 180
        },
        {
          title: '申请金额',
          slot: 'appliedAmt',
          minWidth: 100
        },
        {
          title: '退款申请渠道',
          slot: 'refundReqType', // 退款渠道类型 0：默认 1：家长发起 2：后台订单发起 3：开班失败批量退款 4：分班后批量退款 5：请假可退款
          minWidth: 150
        },
        {
          title: '退款创建时间',
          key: 'appliedTime',
          minWidth: 200
        }
      ],
      leaveListColumns: [
        {
          title: '请假单号',
          key: 'appliedId',
          minWidth: 200
        },
        {
          title: '订单编号',
          key: 'orderId',
          minWidth: 200
        },
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 120
        },
        {
          title: '学校名称',
          key: 'schoolName',
          tooltip: true,
          minWidth: 180
        },
        {
          title: '年级班级',
          key: 'gradeClassName',
          minWidth: 120
        },
        {
          title: '学期',
          key: 'yearTerm',
          minWidth: 200
        },
        {
          title: '退款类型',
          key: 'refundType',
          minWidth: 120
        },
        {
          title: '商品名称',
          key: 'offerName',
          tooltip: true,
          minWidth: 200
        },
        {
          title: '机构名称',
          key: 'orgName',
          tooltip: true,
          minWidth: 170
        },
        {
          title: '上课时间',
          slot: 'classTimeDesc',
          tooltip: true,
          minWidth: 180
        },
        {
          title: '申请金额',
          slot: 'appliedAmt',
          minWidth: 100
        }, {
          title: '请假单创建时间',
          key: 'appliedTime',
          minWidth: 200
        }
      ],
      tableList: [],
      loading: false,
      pageInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      pageSizeOpts: [10, 20, 50, 100],
      isSaveing: false,
      searchData: {},
      hasGetSearch: false,
      refundFee: 0,
      leaveRefundFee: 0,
      taskId: '',
      resultModalText: '', // 结果弹窗
      modalType: 0,
      checkType: '',
      codeModalText: '',
      selectRefundList: [],
      selectLeaveList: [],
      tabActive: '1',
      refundReqTypeInfo: {
        0: '默认',
        1: '家长发起',
        2: '后台订单发起',
        3: '开班失败批量退款',
        4: '分班后批量退款',
        5: '请假可退款',
        6: '教务发起'
      } // 退款渠道类型 0：默认 1：家长发起 2：后台订单发起 3：开班失败批量退款 4：分班后批量退款 5：请假可退款
    };
  },
  computed: {
    listColumnsShow() {
      let columns = [];
      if (this.tabActive === '1') {
        columns = columns.concat(this.refundListColumns);
      } else if (this.tabActive === '2') {
        columns = columns.concat(this.leaveListColumns);
      }
      if (this.sheetId) {
        columns.unshift({
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        });
      }
      return columns;
    },

    tabs() {
      const list = [];
      if (this.searchData.refundApplyTimeBegin) {
        list.push({
          name: '退款申请单',
          value: '1'
        });
      }
      if (this.searchData.leaveTimeBegin) {
        list.push({
          name: '请假申请单（可退款）',
          value: '2'
        });
      }
      console.log('tabs变化了', list);
      return list;
    },
    totalFee() {
      return +this.refundFee + +this.leaveRefundFee;
    },
    refundFeeForSelect() {
      return this.selectRefundList.reduce((prev, curr) => {
        return add(prev, curr.appliedAmt);
      }, 0);
    },
    selectRefundIds() {
      return this.selectRefundList.map(item => {
        return item.appliedId;
      });
    },
    leaveFeeForSelect() {
      return this.selectLeaveList.reduce((prev, curr) => {
        return add(prev, curr.appliedAmt);
      }, 0);
    },
    selectLeaveIds() {
      return this.selectLeaveList.map(item => {
        return item.appliedId;
      });
    },
    totalFeeForSelect() {
      return add(this.refundFeeForSelect, this.leaveFeeForSelect);
    }
  },
  watch: {
    tabs: {
      handler(newVal, oldVal) {
        if (newVal.length === 1 && this.searchData.leaveTimeBegin) {
          console.log('切换了2');
          this.tabActive = '2';
        }
        if (newVal.length === 1 && this.searchData.refundApplyTimeBegin) {
          console.log('切换了1');
          this.tabActive = '1';
        }
      },
      deep: true
    }
  },
  methods: {
    // 添加明细的时候，勾选表格数据
    getSelection(selection) {
      if (this.tabActive === '1') {
        this.selectRefundList = selection;
      } else if (this.tabActive === '2') {
        this.selectLeaveList = selection;
      }
    },
    // 添加明细的时候，回显上次创建请款的搜索参数
    setDetails(data) {
      this.$refs.searchRef.setSearchConds(data);
    },
    // 点击搜索按钮进行查询
    getParams(data, typeList) {
      const { refundApplyTimeBegin, refundApplyTimeEnd, leaveTimeBegin, leaveTimeEnd } = data;
      if (!refundApplyTimeBegin && !refundApplyTimeEnd && !leaveTimeBegin && !leaveTimeEnd) {
        this.$Message.error('请至少选择一项退款内容');
        return;
      }
      const params = { ...data };
      if (typeList.length === 1) {
        params.classType = typeList[0];
      } else if (typeList.length === 2) {
        params.classType = typeList[0];
        params.courseTypeKinds = [+typeList[1]];
      }
      this.searchData = params;
      this.hasGetSearch = true;
      this.$nextTick(() => {
        this.getResultList();
      });
    },
    // 获取列表
    async getResultList() {
      this.pageInfo.total = 0;
      this.pageInfo.pageNum = 1;
      this.refundFee = 0;
      this.leaveRefundFee = 0;
      if (this.searchData.refundApplyTimeBegin) {
        this.getRefundFee();
      }
      if (this.searchData.leaveTimeBegin) {
        this.getLeaveRefundFee();
      }
      console.log('请求数据----345');
      if (this.tabActive === '1') {
        this.getRefundApplyList();
      } else if (this.tabActive === '2') {
        this.getLeaveApplyList();
      }
    },
    // 点击切换tab
    tabChange(value) {
      this.pageInfo.total = 0;
      this.pageInfo.pageNum = 1;
      this.tabActive = value;
      if (value === '1') {
        this.getRefundApplyList();
      } else if (value === '2') {
        this.getLeaveApplyList();
      }
    },
    // 获取退款订单金额统计
    async getRefundFee() {
      const { leaveTimeBegin, leaveTimeEnd, ...otherData } = this.searchData;
      const params = {
        ...otherData,
        ...this.searchConds
      };
      const res = await orderCenterApi.getRequestSheetListStatisticsApi(params);
      if (res.status === 200) {
        this.refundFee = res.message.totalAmt;
      }
    },
    // 获取请假可退款金额统计
    async getLeaveRefundFee() {
      const { refundApplyTimeBegin, refundApplyTimeEnd, ...otherData } = this.searchData;
      const params = {
        ...otherData,
        ...this.searchConds
      };
      const res = await orderCenterApi.getRequestLeaveOrderStatisticseApi(params);
      if (res.status === 200) {
        this.leaveRefundFee = res.message.totalAmt;
      }
    },
    // 获取退款订单列表
    async getRefundApplyList() {
      const { pageNum, pageSize } = this.pageInfo;
      const { leaveTimeBegin, leaveTimeEnd, ...otherData } = this.searchData;
      const params = {
        ...otherData,
        ...this.searchConds,
        pageNum, pageSize
      };
      this.loading = true;
      try {
        const res = await orderCenterApi.getRequestRefundOrderPageApi(params);
        if (res.status === 200) {
          this.tableList = res.message.list.map(item => {
            item._checked = this.selectRefundIds.includes(item.appliedId);
            return item;
          });
          this.pageInfo.total = +res.message.total;
        }
      } finally {
        this.loading = false;
      }
    },
    // 获取请假可退款订单列表
    async getLeaveApplyList() {
      const { pageNum, pageSize } = this.pageInfo;
      const { refundApplyTimeBegin, refundApplyTimeEnd, ...otherData } = this.searchData;
      const params = {
        ...otherData,
        ...this.searchConds,
        pageNum, pageSize
      };
      this.loading = true;
      try {
        const res = await orderCenterApi.getRequestLeaveOrderPageApi(params);
        if (res.status === 200) {
          this.tableList = res.message.list.map(item => {
            item._checked = this.selectLeaveIds.includes(item.appliedId);
            return item;
          });
          this.pageInfo.total = +res.message.total;
        }
      } finally {
        this.loading = false;
      }
    },
    // 页码改变
    pageChange(page) {
      this.pageInfo.pageNum = page;
      if (this.tabActive === '1') {
        this.getRefundApplyList();
      } else if (this.tabActive === '2') {
        this.getLeaveApplyList();
      }
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      if (this.pageInfo.pageNum !== 1) {
        return;
      }
      if (this.tabActive === '1') {
        this.getRefundApplyList();
      } else if (this.tabActive === '2') {
        this.getLeaveApplyList();
      }
    },
    handleToLastStep() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否回到上一步？回到上一步后当前数据将不会保存</p>',
        onOk: () => {
          this.$emit('toLastStep');
        }
      });
    },
    // 点击保存按钮
    handleCheckAllForm() {
      if (!this.searchData.refundApplyTimeBegin && !this.searchData.leaveTimeBegin) {
        this.$Message.error('请至少选择一项退款内容');
        return;
      }
      if (this.totalFee === 0 && !this.sheetId) {
        this.$Message.error('请先选择申请退款内容');
        return;
      }
      if (this.selectRefundIds.length === 0 && this.selectLeaveIds.length === 0 && this.sheetId) {
        this.$Message.error('请先选择要增加的明细');
        return;
      }
      if (this.sheetId) {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>请仔细核对退款的申请单，确认后系统即根据【退款内容】进行自动汇总退款申请的处理，是否确认该操作？</p>',
          loading: true,
          onOk: () => {
            this.addSheetDetails();
          }
        });
      } else {
        this.checkType = 'req_refund_sheet_add';
        this.codeModalText = '请仔细核对退款的申请单，确认后系统即根据【退款内容】进行自动汇总退款申请的处理，是否确认该操作？';
        this.$refs.checkCodeModalRef.handleOpen();
      }
    },
    // 输入验证码之后
    getPhoneCode(code) {
      this.openModal('loadingModal');
      this.createSheet(code);
    },
    // 创建请款单
    async createSheet(code) {
      const { classType, offerOrgType } = this.searchData;
      const params = {};
      if (classType) {
        params.classTypes = (classType + '').split(',');
      }
      if (offerOrgType) {
        params.courseOrgType = offerOrgType;
      }
      try {
        const res = await orderCenterApi.addRequestRefundSheetApi({
          ...this.searchData,
          ...this.searchConds,
          orgId: this.searchConds.schoolId,
          orgName: this.searchConds.schoolName,
          ...params,
          smsCode: code
        });
        this.$refs.checkCodeModalRef.setErrorStr('');
        this.closeModal('loadingModal');
        if (res.status === 200) {
          this.$refs.checkCodeModalRef.handleClose();
          this.modalType = 1;
          this.resultModalText = '退款申请单创建成功';
          this.openModal('resultModal');
        } else if (res.status === 3505 || res.status === 3504) {
          this.$refs.checkCodeModalRef.setErrorStr(res.error);
        } else {
          this.resultModalText = res.error ? res.error : '退款申请单创建失败！请刷新后重新发起!';
          this.modalType = -1;
          this.openModal('resultModal');
          this.$refs.checkCodeModalRef.handleClose();
        }
      } finally {
        this.closeModal('loadingModal');
      }
    },
    // 添加请款单的明细
    async addSheetDetails() {
      const params = {
        sheetId: this.sheetId,
        refundOrderIds: this.selectRefundIds, // 退款单号
        leaveIds: this.selectLeaveIds // 请假单号
      };
      let hasRemoveModal = false;
      try {
        const res = await orderCenterApi.appendItemsRefundSheetApi(params);
        this.$Modal.remove();
        hasRemoveModal = true;
        if (res.status === 200) {
          this.modalType = 1;
          this.resultModalText = '增加明细成功';
          this.openModal('resultModal');
        } else {
          this.modalType = -1;
          this.resultModalText = res.error ? res.error : '增加明细成功失败';
          this.openModal('resultModal');
        }
      } finally {
        if (!hasRemoveModal) {
          this.$Modal.remove();
        }
      }
    },
    // 打开弹窗
    openModal(type) {
      this.$nextTick(() => {
        this.$refs[type].open();
      });
    },
    // 关闭弹窗
    closeModal(type) {
      this.$nextTick(() => {
        this.$refs[type].close();
      });
    },
    // 点击了提示弹窗的确定按钮
    handleClickSure() {
      if (this.modalType === 1) {
        this.handleGoBack();
      } else {
        this.closeModal('resultModal');
      }
    },
    // 返回上一页列表页
    handleGoBack() {
      if (this.sheetId) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: 'orderCenter_afterSale_refundApplicationList'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-index {
  padding-bottom: 150px !important;
  .block-content{
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
    position: relative;
    .block-title{
      border: 1px solid rgb(121, 121, 121);
      padding: 0 10px;
      height: 24px;
      font-size: 14px;
      line-height: 24px;
      border-radius: 10px;
      position: absolute;
      top: -10px;
      left: -10px;
      background: rgb(215, 215, 215);
      color: rgb(51, 51, 51);
      font-weight: 600;
    }
  }
  .block-content+.block-content{
    margin-top: 50px;
  }
}
.time-block{
  display: inline-block;
  line-height: 25px;
  padding: 5px 0;
}
.content-430{
  /deep/.ivu-alert-warning{
    display: inline-block;
  }
}
</style>
